export default {
    path: '/generalDepartment',
    redirect: '/generalDepartment/notice/list',
    meta: {
        title: "综合部",
        permissionCode: "pcGeneral"
    },
    children: [
        {
            path: 'massageInfo',
            name: 'massageInfo',
            component: () => import("@/views/generalDepartment/massageInfo/index.vue"),
            meta: {
                permissionCode: "pcGeneralMassageInfo",
                title: '企业信息',


            },
        }, {
            path: 'certificateManage/list',
            name: 'certificateManage',
            component: () => import("@/views/generalDepartment/certificateManage/list.vue"),
            meta: {
                permissionCode: "pcGeneralCertificateManage",
                title: '企业证书管理',
                keepAlive: true,
                name:"pcGeneralCertificateManage"
            },
        },
        {
            path: 'certificateManage/details',
            name: 'certificateManageDetails',
            component: () => import("@/views/generalDepartment/certificateManage/details.vue"),
            meta: {
                permissionCode: "pcGeneralCertificateManageEdit",
                title: '证书添加/编辑',
                keepAlive: true,
                name:"pcGeneralCertificateManageForm"
            },
        },
        {
            path: 'certificateManage/downList',
            name: 'certificateManageDownList',
            component: () => import("@/views/generalDepartment/certificateManage/downList.vue"),
            meta: {
                permissionCode: "pcGeneralCertificateManage",
                title: '下载日志',
            },
        },
        {
            path: 'notice/list',
            name: 'noticeList',
            component: () => import("@/views/generalDepartment/notice/list/index.vue"),
            meta: {
                permissionCode: "pcGeneralNoticeList",
                title: '企业公告管理',
                keepAlive: true,
                name: "pcGeneralNoticeList"
            },
        },
        {
            path: 'institution/List',
            name: 'institutionList',
            component: () => import("@/views/generalDepartment/institution/list.vue"),
            meta: {
                permissionCode: "pcGeneralInstitutionList",
                title: '企业制度管理',
                name:"pcGeneralInstitutionList",
                keepAlive: true,
            },
        },
        {
            path: 'institution/details',
            name: 'institutionDetails',
            component: () => import("@/views/generalDepartment/institution/details.vue"),
            meta: {
                permissionCode: "pcGeneralInstitutionListEdit",
                title: '企业制度新增/修改',
                name:"pcGeneralInstitutionListForm",
                keepAlive: true,
            },
        },
        {
            path: 'customerInto/List',
            name: 'customerIntoList',
            component: () => import("@/views/generalDepartment/customerInto/list.vue"),
            meta: {
                permissionCode: "pcGeneralCustomerIntoList",
                title: '客户信息入库登记',
            },
        },
        {
            path: 'notice/readList',
            name: 'noticeReadList',
            component: () => import("@/views/generalDepartment/notice/readList/index.vue"),
            meta: {
                permissionCode: "pcGeneralNoticeList",
                title: '企业公告管理',
            },
        },
        {
            path: 'notice/create',
            name: 'noticeCreate',
            component: () => import("@/views/generalDepartment/notice/create/index.vue"),
            meta: {
                permissionCode: "pcGeneralNoticeListEdit",
                title: '企业公告新增/编辑',
                name:"pcGeneralNoticeListForm",
                keepAlive: true,
            },
        },
        {
            path: 'notice/detail',
            name: 'noticeDetail',
            component: () => import("@/views/generalDepartment/notice/detail/index.vue"),
            meta: {
                permissionCode: "pcGeneralNoticeListAuth",
                title: '企业公告详情',
            },
        },

        {
            path: 'labourPayment/list',
            name: 'labourPaymentList',
            component: () => import("@/views/generalDepartment/labourPayment/list/index.vue"),
            meta: {
                permissionCode: "pcGeneralLabourPaymentList",
                title: '劳务付款确认',
                keepAlive: true,
                name: "pcGeneralLabourPaymentList"
            },
        }, {
            path: 'labourTax/list',
            name: 'labourTaxList',
            component: () => import("@/views/generalDepartment/labourTax/list/index.vue"),
            meta: {
                permissionCode: "pcGeneralLabourTaxList",
                title: '劳务税金登记',
                keepAlive: true
            },
        }, {
            path: 'labourTax/create',
            name: 'labourTaxCreate',
            component: () => import("@/views/generalDepartment/labourTax/create/index.vue"),
            meta: {
                permissionCode: "pcGeneralLabourTaxList",
                title: '劳务税金登记',
                keepAlive: true
            },
        }, {
            path: 'sealManage/list',
            name: 'sealManageList',
            component: () => import("@/views/generalDepartment/sealManage/list/index.vue"),
            meta: {
                permissionCode: "pcGeneralSealManage",
                title: '用章登记',
                keepAlive: true,
                name: "pcGeneralSealManage",
            },
        }, {
            path: 'weeklyManage/list',
            name: 'weeklyManageList',
            component: () => import("@/views/generalDepartment/weeklyManage/list/index.vue"),
            meta: {
                permissionCode: "pcGeneralWeeklyManage",
                title: '工作周报管理',
                keepAlive: true,
                name: "pcGeneralWeeklyManage"
            },
        }, {
            path: '/generalDepartment/officeSuppliesManage/list',
            name: 'officeSuppliesManageList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/list/index.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageList",
                title: '办公用品信息管理',
                keepAlive: true,
                name: "pcGeneralOfficeSuppliesManageList"
            },
        },
        {
            path: '/generalDepartment/officeSuppliesManage/details',
            name: 'officeSuppliesManageDetails',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/list/details.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageList",
                title: '办公用品信息管理',
            },
        },
        {
            path: '/generalDepartment/officeSuppliesManage/supplier/list',
            name: 'officeSuppliesManageSupplierList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/supplier/list.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageSupplierList",
                title: '办公用品供应商管理',
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageSupplierList"
            },
        },
        {
            path: '/generalDepartment/officeSuppliesManage/supplier/details',
            name: 'officeSuppliesManageSupplierDetails',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/supplier/details.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageSupplierList",
                title: '办公用品供应商管理',
            },
        },
        {
            path: '/generalDepartment/officeSuppliesManage/purchase/list',
            name: 'officeSuppliesManagePurchaseList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/purchase/list.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManagePurchaseList",
                title: '办公用品采购申请',
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManagePurchaseList",
            },
        },
        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/list',
            name: 'pcGeneralOfficeSuppliesManageStockManageList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/list.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageList",
                title: '办公用品库存管理',
                keepAlive: true
            }
        },
        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/into/list',
            name: 'officeSuppliesManageStockManageIntoList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/into/list.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageIntoList",
                title: '办公用品入库登记',
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageStockManageIntoList"
            }
        },
        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/into/details',
            name: 'officeSuppliesManageStockManageIntoDetails',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/into/details.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageIntoListEdit",
                title: '办公用品入库登记/修改',
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageStockManageIntoListForm"
            }
        },
        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/use/list',
            name: 'officeSuppliesManageStockManageUseList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/use/list.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageUseList",
                title: '办公用品领用登记',
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageStockManageUseList"
            }
        },
        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/out/list',
            name: 'officeSuppliesManageStockManageOutList',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/out/list.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageOutList",
                title: '办公用品出库登记',
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageStockManageOutList"
            }
        },

        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/out/scrapDetails',
            name: 'officeSuppliesManageStockManageScrapDetails',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/out/details.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageOutListscrap",
                title: '报废登记',
                state: "scrap",
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageStockManageOutForm"
            }
        },

        {
            path: '/generalDepartment/officeSuppliesManage/stockManage/out/welfareDetails',
            name: 'officeSuppliesManageStockManageWelfareDetails',
            component: () => import("@/views/generalDepartment/officeSuppliesManage/stockManage/out/details.vue"),
            meta: {
                permissionCode: "pcGeneralOfficeSuppliesManageStockManageOutListwelfare",
                title: '福利发放',
                state: "welfare",
                keepAlive: true,
                name:"pcGeneralOfficeSuppliesManageStockManageOutForm"
            }
        },
        {
            path: '/generalDepartment/hrManage/staff/list',
            name: 'pcGeneralHrManageStaffList',
            component: () => import("@/views/generalDepartment/hrManage/staff/list.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageStaffList",
                title: '员工信息管理',
                keepAlive: true,
                name:"pcGeneralHrManageStaffList",
            },
        },
        {
            path: '/generalDepartment/hrManage/staff/details',
            name: 'pcGeneralHrManageStaffAdd',
            component: () => import("@/views/generalDepartment/hrManage/staff/details.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageStaffList",
                title: '员工信息新增/编辑',
                keepAlive: true,
                name:"pcGeneralHrManageStaffListForm",
            },
        },
        {
            path: '/generalDepartment/hrManage/staff/view',
            name: 'pcGeneralHrManageStaffView',
            component: () => import("@/views/generalDepartment/hrManage/staff/view.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageStaffList",
                title: '员工视图',
            },
        },
        {
            path: '/generalDepartment/hrManage/sympathy/list',
            name: 'pcGeneralHrManageSympathyList',
            component: () => import("@/views/generalDepartment/hrManage/sympathy/list.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageSympathyList",
                title: '项目慰问记录',
                keepAlive: true,
                name:"pcGeneralHrManageSympathyList"
            },
        },
        {
            path: '/generalDepartment/hrManage/sympathy/details',
            name: 'pcGeneralHrManageSympathyDetails',
            component: () => import("@/views/generalDepartment/hrManage/sympathy/details.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageSympathyList",
                title: '项目慰问记录新增/修改',
                keepAlive: true,
                name:"pcGeneralHrManageSympathyListForm",
            },
        },
        {
            path: '/generalDepartment/hrManage/interview/list',
            name: 'pcGeneralHrManageInterviewList',
            component: () => import("@/views/generalDepartment/hrManage/interview/list.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageInterviewList",
                title: '面试信息管理',
                name:"pcGeneralHrManageInterviewList",
                keepAlive:true
            },
        },
        {
            path: '/generalDepartment/hrManage/interview/addDetails',
            name: 'pcGeneralHrManageInterviewAddDetails',
            component: () => import("@/views/generalDepartment/hrManage/interview/details.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageInterviewListAdd",
                title: '面试信息添加',
                state: "add",
                keepAlive: true,
                name:"pcGeneralHrManageInterviewListForm",
            },
        },
        {
            path: '/generalDepartment/hrManage/interview/editDetails',
            name: 'pcGeneralHrManageInterviewEditDetails',
            component: () => import("@/views/generalDepartment/hrManage/interview/details.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageInterviewListEdit",
                title: '面试信息修改',
                state: "edit",
                keepAlive: true,
                name:"pcGeneralHrManageInterviewListForm",
            },
        },
        {
            path: '/generalDepartment/hrManage/interview/seeDetails',
            name: 'pcGeneralHrManageInterviewSeeDetails',
            component: () => import("@/views/generalDepartment/hrManage/interview/details.vue"),
            meta: {
                permissionCode: "pcGeneralHrManageInterviewListDetail",
                title: '面试信息详情',
                state: "see",
                keepAlive: true,
                name:"pcGeneralHrManageInterviewListForm",
            },
        },
        {
            path: '/generalDepartment/documentsManage/first/list',
            name: 'generalDocumentsManageFirstList',
            component: () => import("@/views/generalDepartment/documentsManage/first/list.vue"),
            meta: {
                permissionCode: "pcGeneralDocumentsManageFirstList",
                title: '甲方合同管理',
            },
        },

        {
            path: '/generalDepartment/documentsManage/supplier/list',
            name: 'generalDocumentsManageSupplierList',
            component: () => import("@/views/generalDepartment/documentsManage/supplier/list.vue"),
            meta: {
                permissionCode: "pcGeneralDocumentsManageSupplierList",
                title: '供应商合同管理',
                keepAlive: true

            },
        },
        {
            path: 'weeklyMgt',
            name: 'weeklyMgt',
            redirect: 'weeklyMgt/statistics/list',
            meta: {
                title: "报表管理",
                permissionCode: "pcGeneralWeeklyMgt",
            },
            component: () => import("@/router/EmptyComponent.vue"),
            children: [
                {
                    path: '/generalDepartment/weeklyMgt/statistics/list',
                    name: 'pcGeneralWeeklyMgtStatistics',
                    component: () => import("@/views/generalDepartment/weeklyMgt/statistics.vue"),
                    meta: {
                        permissionCode: "pcGeneralWeeklyMgtStatistics",
                        title: '周报统计',
                        keepAlive: true
                    },
                },
                {
                    path: '/generalDepartment/weeklyMgt/journal/list',
                    name: 'pcGeneralWeeklyMgtJournal',
                    component: () => import("@/views/generalDepartment/weeklyMgt/journal.vue"),
                    meta: {
                        permissionCode: "pcGeneralWeeklyMgtJournal",
                        title: '工作日志',
                        keepAlive: true
                    },
                },
            ]
        }
    ]
}